// extracted by mini-css-extract-plugin
module.exports = {"pt-checkbox":"pt-checkbox-315229dc075c1a83027377db636cb890"};